import { createApiSlice } from 'app/createApiSlice'
import { API_PROJECT } from 'utils/apiList'

export const projectApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'project/api',
  endpoints(builder) {
    return {
      fetchProject: builder.query({
        query({
          userId,
          s,
          isAgent = 0,
          page = 0,
          size = 10,
          sortby = 'label',
          sortdir = 'asc',
          isPhone,
          isEmail,
          isRegistered,
        }) {
          const params = {
            userId,
            search: s,
            isAgent,
            page,
            size,
            sortby,
            sortdir,
          }

          if (isPhone !== undefined) params.isPhone = isPhone
          if (isEmail !== undefined) params.isEmail = isEmail
          if (isRegistered !== undefined) params.isRegistered = isRegistered

          return {
            url: API_PROJECT,
            params,
          }
        },
      }),
      findProject: builder.query({
        query({
          s,
          page = 0,
          size = 10,
          sortby = 'label',
          sortdir = 'asc',
          isPhoneUnRegistered,
          isPhoneRegistered,
          isEmailUnRegistered,
          isEmailRegistered,
          isPhoneVerified,
          isEmailVerified,
          isHarvester,
          isLandOwner,
        }) {
          const params = {
            search: s,
            page,
            size,
            sortby,
            sortdir,
          }

          if (isPhoneUnRegistered !== undefined)
            params.isPhoneUnRegistered = isPhoneUnRegistered
          if (isPhoneRegistered !== undefined)
            params.isPhoneRegistered = isPhoneRegistered
          if (isEmailUnRegistered !== undefined)
            params.isEmailUnRegistered = isEmailUnRegistered
          if (isEmailRegistered !== undefined)
            params.isEmailRegistered = isEmailRegistered
          if (isPhoneVerified !== undefined)
            params.isPhoneVerified = isPhoneVerified
          if (isEmailVerified !== undefined)
            params.isEmailVerified = isEmailVerified
          if (isHarvester !== undefined) params.isHarvester = isHarvester
          if (isLandOwner !== undefined) params.isLandOwner = isLandOwner

          return {
            url: API_PROJECT,
            params,
          }
        },
      }),
      addProject: builder.mutation({
        query(data) {
          const sanitizedData = Object?.fromEntries(
            Object?.entries(data)?.map(([key, value]) => [
              key,
              value === '' ? null : value,
            ]),
          )

          return {
            url: API_PROJECT,
            method: 'POST',
            body: sanitizedData,
          }
        },
      }),
      removeProject: builder.mutation({
        query({ id }) {
          return {
            url: `${API_PROJECT}/${id}`,
            method: 'DELETE',
          }
        },
      }),
      updateProject: builder.mutation({
        query({ id, ...data }) {
          const sanitizedData = Object.fromEntries(
            Object.entries(data).map(([key, value]) => [
              key,
              value === '' ? null : value,
            ]),
          )

          return {
            url: `${API_PROJECT}/${id}`,
            method: 'PATCH',
            body: sanitizedData,
          }
        },
      }),
    }
  },
})

export const {
  useFetchProjectQuery,
  useLazyFetchProjectQuery,
  useFindProjectQuery,
  useLazyFindProjectQuery,
  useAddProjectMutation,
  useRemoveProjectMutation,
  useUpdateProjectMutation,
} = projectApiSlice
